<mat-dialog-content>
  <div class="aprovacao-tabs tabs" *ngIf="_form">
    <nav class="d-flex justify-center tabs-navegacao navegacao">
      <ng-container
        *ngFor="let tab of tabs; let i = index"
        class="d-flex justify-space-evenly navegacao-container container"
      >
        <button
          class="d-flex justify-center align-center container-label"
          [ngClass]="{ 'tab-active': currentTab === i + 1 }"
          (click)="changeTab(i)"
        >
          {{ tab.title }}
        </button>
      </ng-container>
    </nav>
  </div>

  <form
    class="d-flex direction-column align-center form"
    *ngIf="_form"
    [formGroup]="_form"
  >
    <div
      class="d-flex direction-column align-center justify-space-between form-conteudo conteudo"
    >
      <div class="d-flex direction-column conteudo-section section">
        <h5 class="section-title">Detalhes Contrato</h5>
        <div class="d-flex justify-space-between section-inputs">
          <ng-container *ngFor="let input of inputControlsDetails">
            <app-c-input
              *ngIf="!input.custom"
              class="section-input basis-47"
              [label]="input.label"
              [placeholder]="input.placeholder"
              [readonly]="true"
              [formControlName]="input.controlName"
              [currencyMask]="!!input.currency"
              [inputMask]="input.mask"
              [inputType]="input.type ?? ''"
            >
            </app-c-input>
          </ng-container>

          <ng-container formGroupName="InvoiceBeneficiaries">
            <ng-container *ngFor="let input of invoiceBeneficiariesControls">
              <app-c-input
                class="section-input basis-47"
                [label]="input.label"
                [readonly]="true"
                [placeholder]="input.placeholder"
                [formControlName]="input.controlName"
                [inputMask]="input.mask"
                [currencyMask]="!!input.currency"
                [inputType]="input.type ?? ''"
              >
              </app-c-input>
            </ng-container>
          </ng-container>

          <ng-container formGroupName="TransferBeneficiaries">
            <ng-container *ngFor="let input of transferBeneficiariesControls">
              <app-c-input
                class="section-input basis-47"
                [label]="input.label"
                [placeholder]="input.placeholder"
                [formControlName]="input.controlName"
                [readonly]="true"
                [inputMask]="input.mask"
                [currencyMask]="!!input.currency"
                [inputType]="input.type ?? ''"
              >
              </app-c-input>
            </ng-container>
          </ng-container>

          <ng-container
            *ngFor="let contract of contractData.ContractCustomFields"
          >
            <app-c-input
              *ngIf="contract.FieldName.toLowerCase() !== 'data do contrato'"
              class="section-input basis-47"
              [label]="contract.FieldName"
              [placeholder]="contract.FieldName"
              [formControlName]="contract.FieldName"
              [readonly]="true"
            >
            </app-c-input>
          </ng-container>

          <div class="d-flex direction-column section-input basis-47">
            <label class="input-label" for="aprovacao-comments"> Observações </label>
            <textarea
              id="aprovacao-comments"
              class="row input-area"
              formControlName="Comments"
              placeholder="Campo de texto livre"
              rows="4"
              maxlength="240"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="d-flex direction-column conteudo-section section">
        <h5 class="section-title">Detalhes Financiamento</h5>
        <div
          class="d-flex justify-space-between section-inputs"
          formGroupName="BatchDetails"
        >
          <ng-container *ngFor="let input of inputControlsFinancy">
            <app-c-input
              class="section-input basis-47"
              [label]="input.label"
              [placeholder]="input.placeholder"
              [readonly]="true"
              [formControlName]="input.controlName"
              [currencyMask]="!!input.currency"
              [inputMask]="input.mask"
              [inputType]="input.type ?? ''"
            >
            </app-c-input>
          </ng-container>
        </div>
      </div>

      <div class="d-flex direction-column conteudo-section section" *ngIf="Beneficiaries.controls?.length">
        <h5 class="section-title">Detalhes Beneficiários</h5>
        <div
          class="d-flex direction-column justify-space-between section-beneficiaries mt-16"
        >
          <ng-container
            *ngFor="
              let beneficiary of Beneficiaries.controls;
              let indexBeneficiary = index
            "
          >
            <app-beneficiary-contract-card
              class="card pt-30"
              [cardType]="BeneficiaryCardEnum.Modal"
              [form]="beneficiary"
              [index]="indexBeneficiary"
              [editableFields]="editableFields[EntityEnum.Beneficiary]"
            ></app-beneficiary-contract-card>
          </ng-container>
        </div>
      </div>
    </div>

    <button
      class="d-flex justify-center align-center form-close close mt-32 ui-btn ui-btn--primary"
      (click)="close(true)"
    >
      Fechar
    </button>
  </form>
</mat-dialog-content>
